'use client'

import classNames from 'clsx'
import { useEffect, useState } from 'react'

import JgglIcon from '@/assets/icons/jggl.svg'
import { JGGL_URLS } from '@/configs/jggl'
import { resolveJgglUrl } from '@/lib/device/resolveJgglUrl'

import S from './Header.module.scss'

type JgglLinkProps = {
  mobile?: boolean
  onNavigate?: () => void
}

export default function JgglLink({
  mobile = false,
  onNavigate
}: JgglLinkProps) {
  const [href, setHref] = useState<string>(JGGL_URLS.website)

  useEffect(() => {
    const resolvedHref = resolveJgglUrl({
      userAgent: navigator.userAgent,
      platform: navigator.platform,
      maxTouchPoints: navigator.maxTouchPoints
    })

    // The server-safe website fallback keeps SSR deterministic; the store URL
    // is selected only after browser device hints become available.
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setHref(resolvedHref)
  }, [])

  return (
    <a
      href={href}
      className={classNames(S.jgglLink, mobile && S.jgglLinkMobile)}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onNavigate}
    >
      <span className={S.jgglLabel}>JGGL IT</span>
      <span className={S.jgglIcon} aria-hidden="true">
        <JgglIcon />
      </span>
    </a>
  )
}
